import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'DonutFire.gg',
    description: 'Set your DonutSMP money on fire. Deposit with /pay, play Coinflip, Dice, Crash and Mines, and cash out straight back to your Minecraft account.',
    placeholder: 'DonutSMP casino',
    url: getOrigin()
}

// The in-game account players /pay to deposit, and the server it lives on.
export const BANK_ACCOUNT = 'DonutFireBank'
export const SERVER_NAME = 'DonutSMP'

// Bet and wallet limits, in whole in-game dollars.
export const MIN_BET = 10_000
export const MAX_BET = 15_000_000_000
export const MIN_DEPOSIT = 10_000
export const MIN_WITHDRAWAL = 10_000
export const MAX_TRANSFER = 1_000_000_000_000

export const GAMES = [
    {
        id: 'coinflip',
        name: 'Coinflip',
        href: '/coinflip',
        tagline: 'Fire or Donut',
        badge: '1.96×',
        subtitle: 'Pick a side · win 1.96×'
    },
    {
        id: 'dice',
        name: 'Dice',
        href: '/dice',
        tagline: 'Set your own odds',
        badge: 'up to 49×',
        subtitle: 'Roll under your number to win'
    },
    {
        id: 'crash',
        name: 'Crash',
        href: '/crash',
        tagline: 'Cash out before it blows',
        badge: '∞×',
        subtitle: 'Cash out before the rocket blows'
    },
    {
        id: 'mines',
        name: 'Mines',
        href: '/mines',
        tagline: 'Dodge the TNT',
        badge: '5×5',
        subtitle: 'Find diamonds, dodge the TNT'
    }
] as const

export const FAQ_ITEMS = [
    {
        question: 'How do I type bet amounts?',
        answer: 'Use a letter instead of the zeros: k is thousand, m is million, b is billion and t is trillion. So 50k is 50,000, 2.5m is 2,500,000 and 1b is 1,000,000,000. Bets go from $10K up to $15B.'
    },
    {
        question: 'Do I need to link my Minecraft account?',
        answer: 'No. Your account is tied to your email. You only type a Minecraft name when you deposit (who is paying) or withdraw (who we pay).'
    },
    {
        question: 'How long do deposits and withdrawals take?',
        answer: 'Staff check every request by hand, usually within a few minutes while they are online. Withdrawals leave your balance right away and are refunded in full if they get rejected.'
    },
    {
        question: 'Where do I use promo codes?',
        answer: 'Open your Wallet and go to the Promo code tab. Each code works once per account.'
    },
    {
        question: 'What are the odds?',
        answer: 'Coinflip pays 1.96×. Dice pays 98 divided by your win chance. Crash and Mines carry a 3% house edge. Every result is decided at random on our server.'
    },
    {
        question: 'Is this official?',
        answer: 'No. DonutFire is fan-made and not affiliated with DonutSMP, Mojang or Microsoft. You must be 18 or older, and only gamble what you can afford to lose.'
    }
] as const
